<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container ref="container" class="vastuualue-view py-0" fill-height fluid>
    <v-app-bar app color="black" dark fixed>
      <hb-back-button :forced-fallback="true" fallback="strategia"/>
      <v-toolbar-title v-if="!loading" style="margin-left: 0">
        <div>
          {{ $tc('vastuualue.title', 1) }}
        </div>
      </v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>
    <v-row v-if="!loading && !hasPermissions">
      <v-col class="mt-5" cols="auto">
        <h3>{{ $t('vastuualue.no_rights') }}</h3>
      </v-col>
    </v-row>
    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading && hasPermissions" class="fill-height">
        <v-col class="fill-height" cols="12" offset-xl="1" xl="10">
          <v-row :style="{overflow: $vuetify.breakpoint.smAndDown ? 'hidden' : 'visible'}" class="fill-height"
                 no-gutters>
            <v-col class="fill-height" cols="12">
              <v-card ref="infoCard" v-touch="{ up: handleHideInfoCard, down: handleShowInfoCard }" color="#191919"
                      outlined>
                <v-expand-transition>
                  <div v-if="showInfoCard">
                    <v-card-title>
                      <v-row class="align-center" no-gutters>
                        <v-col cols="8">
                          <div>
                            <div class="text-subtitle-1 text-md-h5 font-weight-bold white--text">
                              {{ vastuualue.nimi }}
                              <br v-if="$vuetify.breakpoint.xsOnly"/>
                              <v-chip v-if="vastuualue.vastuuuser" :small="$vuetify.breakpoint.smAndDown"
                                      class="mt-n2 font-weight-regular">
                                {{ vastuualue.vastuuuser.firstname }}
                                {{ vastuualue.vastuuuser.lastname }}
                              </v-chip>
                            </div>
                          </div>
                          <div v-if="$vuetify.breakpoint.smAndUp" class="mt-3">
                            <v-autocomplete v-model="vuosi" :items="vuodet" :label="$t('year')" hide-details
                                            style="max-width: 260px"></v-autocomplete>
                          </div>
                        </v-col>
                        <v-col class="fill-height" cols="4">
                          <v-row class="fill-height" justify="end" no-gutters>
                            <v-tooltip bottom>
                              <template v-slot:activator="{on, attrs}">
                                <div v-bind="attrs" v-on="on">
                                  <v-progress-circular :color="$getValmiusprosenttiColor(kokonaisPisteet)"
                                                       :size="$vuetify.breakpoint.xsOnly ? 80 : 110"
                                                       :value="kokonaisPisteet "
                                                       :width="$vuetify.breakpoint.xsOnly ? 10 : 20"
                                                       style="cursor: pointer;"
                                                       @click="goToTehtavatView()">
                                    <span class="text-subtitle-1 text-h6 text-sm-h6">{{
                                        $formatPisteet(kokonaisPisteet)
                                      }} %</span>
                                  </v-progress-circular>
                                </div>
                              </template>
                              {{ $t('vastuualue.siirry_tehtaviin') }}
                            </v-tooltip>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <template v-if="$vuetify.breakpoint.xsOnly">
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-autocomplete v-model="vuosi" :items="vuodet" :label="$t('year')" class="mt-0"
                                        hide-details></v-autocomplete>
                      </v-card-text>
                    </template>
                  </div>
                </v-expand-transition>
                <v-card-text v-if="$vuetify.breakpoint.smAndDown" class="text-center py-0"
                             @click.stop="toggleShowInfoCard">
                  <v-icon color="grey" size="14">mdi
                    {{ showInfoCard ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down' }}
                  </v-icon>
                </v-card-text>
              </v-card>

              <!-- MD AND UP -->
              <v-card v-if="$vuetify.breakpoint.mdAndUp" class="mb-7">
                <v-card-text>
                  <v-row v-if="filteredValintatyypit">
                    <template v-for="(valintatyyppi,index) in filteredValintatyypit">
                      <valintatyyppi-column
                          :key="valintatyyppi.id"
                          :lg="columnLg"
                          :md="columnMd"
                          :valinnat="filteredValinnat"
                          :valintatyyppi="valintatyyppi"
                          :vastuualue="vastuualue"
                          :vuosi="vuosi"
                      />
                      <v-divider v-if="index < filteredValintatyypit.length-1" :key="`divider_${valintatyyppi.id}`"
                                 vertical/>
                    </template>

                  </v-row>
                </v-card-text>
              </v-card>

              <!-- SM AND DOWN -->
              <template v-if="$vuetify.breakpoint.smAndDown">
                <v-row ref="scrollContent" :style="{height: scrollContentHeight}" class="scroll-content" no-gutters>
                  <v-col class="pb-0" cols="12" style="min-height: calc(100% - 48px)">
                    <div class="tab-menu-items ">
                      <v-tabs v-model="tab" background-color="grey darken-4" grow>
                        <template v-for="valintatyyppi in filteredValintatyypit">
                          <v-tab :key="valintatyyppi.id" class="caption">
                            {{ valintatyyppi.nimi }}
                          </v-tab>
                        </template>
                      </v-tabs>
                    </div>
                    <v-tabs-items v-model="tab" style="min-height: calc(100% - 48px)">
                      <div class="pb-3">
                        <template v-for="valintatyyppi in filteredValintatyypit">
                          <v-tab-item :key="valintatyyppi.id">
                            <valintatyyppi-column
                                :lg="columnLg"
                                :md="columnMd"
                                :valinnat="filteredValinnat"
                                :valintatyyppi="valintatyyppi"
                                :vastuualue="vastuualue"
                                :vuosi="vuosi"
                            />
                          </v-tab-item>
                        </template>
                      </div>
                    </v-tabs-items>
                  </v-col>
                </v-row>
              </template>

            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>

  </v-container>
</template>

<script>
import api from '../apicollection';
import dayjs from 'dayjs';
import ValintatyyppiColumn from "@/components/Vastuualue/ValintatyyppiColumn";

export default {
  name: 'VastuualueView',
  components: {ValintatyyppiColumn},
  data() {
    return {
      loading: true,
      vastuualue: {},
      valintatyypit: [],
      valinnat: [],
      pisteet: {},
      users: [],
      saving: false,
      tab: 0,
      showInfoCard: true,
      scrollContentHeight: null,
      loadingTehtavaPisteet: false,
    };
  },

  computed: {
    hasPermissions() {
          return this.$hasEditPermission(this.vastuualue?.id) || this.$hasGuestPermission(this.vastuualue?.id);
    },
    vuodet() {
      return this.$years
    },
    vuosi: {
      get() {
        return this.$route.params.vuosi ? parseInt(this.$route.params.vuosi) : dayjs().year();
      },
      set(vuosi) {
        this.$router.replace({name: 'vastuualue', params: {vuosi: vuosi, id: this.vastuualue.id}});
      }
    },
    filteredValinnat() {

      return structuredClone(this.valinnat).filter(v => v.vuosi === this.vuosi).map(valinta => {
        valinta.pisteet = this.pisteet[valinta.id];
        return valinta;
      });
    },
    filteredValintatyypit() {
      return this.valintatyypit.filter(v => v.vuosi === this.vuosi);
    },
    columnLg() {
      return this.filteredValintatyypit.length === 1 ? 6 : Math.max(3, 12 / this.filteredValintatyypit.length)
    },
    columnMd() {
      return this.filteredValintatyypit.length === 1 ? 6 : Math.max(6, 12 / this.filteredValintatyypit.length)
    },
    kokonaisPisteet() {
      if (!this.pisteet || Object.keys(this.pisteet).length === 0) {
        return 0;
      }
      let painotus = 0;
      let valmiusPisteet = 0;
      Object.values(this.pisteet).forEach(p => {
        painotus += p.painotus;
        valmiusPisteet += p.valmiusPisteet;
      })
      return this.$round(valmiusPisteet / painotus * 100);
    }
  },
  methods: {

    handleHideInfoCard() {
      this.showInfoCard = false;
    },
    handleShowInfoCard() {
      this.showInfoCard = true;
    },
    toggleShowInfoCard() {
      this.showInfoCard = !this.showInfoCard;
    },
    async getVastuualue() {
      const vastuualue = await api.getVastuualue(this.$route.params.id);
      this.vastuualue = vastuualue;
    },
    async getValintatyypit() {
      const valintatyypit = await api.getValintatyypit(this.vastuualue);
      this.valintatyypit = valintatyypit;
    },
    async getValinnat() {
      const valinnat = await api.getValinnat(this.vastuualue);
      this.valinnat = valinnat.map(v => {
        v.pisteet = this.pisteet?.[v.id] || null;
        return v;
      });
    },
    async getTehtavaPisteet() {
      this.loadingTehtavaPisteet = true;
      try {
        const pisteet = await api.getTehtavaPisteet(this.vastuualue.id, this.vuosi);
        this.pisteet = pisteet;
      } catch (e) {
        console.error(e);
      }
      this.loadingTehtavaPisteet = false;
    },
    async goToTehtavatView() {
      this.$router.push({
        name: 'tehtavat_vuosi_vastuualue',
        params: {vuosi: this.vuosi, vastuualueId: this.vastuualue.id,}
      })
    },

  },
  watch: {
    vuosi() {
      this.getTehtavaPisteet()
    },
    tab() {
      if (this.$refs.scrollContent)
        this.$refs.scrollContent.scrollTop = 0;
    },
    showInfoCard() {
      setTimeout(() => {
        this.scrollContentHeight = `calc(100% - ${this.$refs?.infoCard?.$el.offsetHeight}px)`;
      }, 400);
    }
  },
  async mounted() {
    await Promise.all([this.getVastuualue()])
    await Promise.all([this.getValintatyypit(), this.getValinnat()]).then(() => {
      this.getTehtavaPisteet()
    })

    this.loading = false;

    setTimeout(() => {
      this.scrollContentHeight = `calc(100% - ${this.$refs?.infoCard?.$el.offsetHeight}px)`;
    }, 400);

    this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss">
@media screen and (max-width: 960px) {
  .vastuualue-view {
    height: calc(100vh - 56px);
    overflow: hidden;
  }
}

.tab-menu-items {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 1;
}

.scroll-content {
  overflow: auto;
  position: relative;
}
</style>
